import type ProSkillAssureAssessmentSetResponse
    from '~~/package/apis/ProSkillAssure/response/ProSkillAssureAssessmentSetResponse';
import {
    ProSkillAssureAssessmentModel
} from '~~/package/mapper/proSkillAssure/model/assessment/ProSkillAssureAssessmentModel';
import {LearningTaskModel} from '~~/package/mapper/learning/model/LearningTaskModel';
import {
    ProSkillAssureAssessmentSetModel
} from '~~/package/mapper/proSkillAssure/model/assessment/ProSkillAssureAssessmentSetModel';
import type ProSkillAssureAssessmentDetailResponse
    from '~~/package/apis/ProSkillAssure/response/ProSkillAssureAssessmentDetailResponse';
import {
    ProSkillAssureAssessmentDetailModel
} from '~~/package/mapper/proSkillAssure/model/ProSkillAssureAssessmentDetailModel';
import {ProSkillAssureTrackLevelModel} from '~~/package/mapper/proSkillAssure/model/ProSkillAssureTrackLevelModel';
import {
    ProSkillAssureAssessmentSetInfoModel
} from '~~/package/mapper/proSkillAssure/model/ProSkillAssureAssessmentSetInfoModel';
import {ProSkillAssureTestTemplateModel} from '~~/package/mapper/proSkillAssure/model/ProSkillAssureTestTemplateModel';
import {LevelAssessmentResultModel} from '~~/package/mapper/levelAssessment/model/LevelAssessmentResultModel';
import type ProSkillAssureTaskResponse from '~~/package/apis/ProSkillAssure/response/ProSkillAssureTaskResponse';
import {TaskModel} from '~~/package/mapper/learning/model/TaskModel';
import {MultipleChoiceQuestionModel} from '~~/package/mapper/learning/model/MultipleChoiceQuestionModel';
import {ProSkillAssureTrackModel} from '~~/package/mapper/proSkillAssure/model/ProSkillAssureTrackModel';
import type {ProSkillManagerType} from '~~/package/mapper/proSkillManager/model/ProSkillManagerType';

export class ProSkillAssureHelper {
    public static mappingProSkillAssureAssessment(response: ProSkillAssureAssessmentSetResponse): ProSkillAssureAssessmentModel {
        return ProSkillAssureAssessmentModel.create({
            ...response,
            title: response.name,
            setList: response.sets.map((set, index) => {
                return ProSkillAssureAssessmentSetModel.create({
                    index,
                    templateId: set.testTemplateId,
                    trackTitle: set.trackTitle,
                    trackLevelTitle: set.trackLevelTitle,
                    taskList: set.setQuestions.map(question => LearningTaskModel.create({
                        ...question,
                        id: question.taskId,
                        completeFlag: question.isSubmission
                    }))
                })
            })
        });
    }

    public static mappingProSkillAssureAssessmentDetail(response: ProSkillAssureAssessmentDetailResponse): ProSkillAssureAssessmentDetailModel {
        return ProSkillAssureAssessmentDetailModel.create({
            ...response,
            type: response.type as ProSkillManagerType,
            setList: response.assessmentSetInfoVOList.map(setInfo => {
                return ProSkillAssureTrackLevelModel.create({
                    trackType: setInfo.trackType,
                    trackLevelId: setInfo.trackLevelId,
                    title: setInfo.trackTitle,
                    description: "",
                    testTemplateList: [ProSkillAssureTestTemplateModel.create({id: setInfo.testTemplateId})],
                    referenceUrl: setInfo.referenceUrl,
                    referenceUrlExposureFlag: setInfo.referenceUrlExposureFlag,
                    assessmentContentType: setInfo.assessmentContentType,
                    assessmentSetInfoVO: ProSkillAssureAssessmentSetInfoModel.create({
                        trackId: setInfo.trackId,
                        trackLevelMapTestTemplateMapCustomAssessmentId: setInfo.trackLevelMapTestTemplateMapCustomAssessmentId,
                        setsOrder: setInfo.setsOrder,
                        trackLevelTitle: setInfo.trackLevelTitle,
                        trackTitle: setInfo.trackTitle,
                        taskCount: setInfo.taskCount,
                        recommendTime: setInfo.recommendTime
                    })
                })
            })
        });
    }

    public static mappingProSkillAssureAssessmentSampleList(response: LevelAssessmentResultModel[]): LevelAssessmentResultModel[] {
        return response.map(result => {
            return LevelAssessmentResultModel.create({
                ...result,
                submissionAnswer: result.submissionAnswer
                    ? result.submissionAnswer.map(answer => answer.toString())
                    : undefined
            });
        });
    }

    public static mappingTask(response: ProSkillAssureTaskResponse): TaskModel {
        return TaskModel.create({
            ...response,
            submitCode: response.submissionCode,
            multipleChoiceQuestion: MultipleChoiceQuestionModel.create({
                ...response.multipleChoiceQuestion,
                multipleChoiceResult: {
                    id: 0,
                    testQuestionId: 0,
                    answerList: response.multipleChoiceSubmissionAnswers.map(num => parseInt(num)),
                    userId: 0,
                }
            })
        });
    }

    public static mappingProSkillAssureAssessmentWith(track: ProSkillAssureTrackModel): ProSkillAssureTrackModel {
        return ProSkillAssureTrackModel.create({
            ...track,
            trackLevelAssessmentSetVOList: track.trackLevelAssessmentSetVOList.map(set => {
                return ProSkillAssureTrackLevelModel.create({
                    ...set,
                    trackType: track.trackType
                })
            })
        });
    }
}
